import { CoreIcon } from '../core-icon';
import linkCircleFillSVG from '../../assets/icons/link-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const LinkCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={linkCircleFillSVG} {...props} />;
};
